import React from 'react';

import { FormComponent, UiComponent } from 'components';
import * as BoxStyles from 'components/ui/Box/style/box';
import { useCheck, useDate } from 'hooks';

const CHECK_LIST: {
  id: string;
  displayValue: string;
}[] = [
  { id: '1', displayValue: '발행완료' },
  { id: '2', displayValue: '지급완료' },
  { id: '3', displayValue: '사용완료' },
];

function Filter() {
  const dateState = useDate({});
  const checkListProps = useCheck({
    uniqueKey: 'id',
    data: CHECK_LIST,
    isAllChecked: true,
  });

  return (
    <UiComponent.Box>
      <FormComponent.Form>
        <div css={BoxStyles.rows}>
          <UiComponent.FilterTitle title="검색어" />
          <FormComponent.Select
            options={[
              { name: '발급대상 회원번호', value: '1' },
              { name: '발급대상 회원이름', value: '2' },
              { name: '쿠폰번호', value: '3' },
            ]}
          />
          <FormComponent.Input css={{ width: '500px' }} />
        </div>
        <div css={BoxStyles.rows}>
          <UiComponent.FilterTitle title="기간" />
          <FormComponent.Select
            options={[
              { name: '생성일', value: '1' },
              { name: '사용일', value: '2' },
              { name: '발급일', value: '3' },
            ]}
          />
          <FormComponent.DateRangePicker {...dateState} />
        </div>
        <div css={[BoxStyles.rows]}>
          <UiComponent.FilterTitle title="쿠폰상태" />
          <div css={[BoxStyles.rows, { gap: '0 24px' }]}>
            <FormComponent.CheckList {...checkListProps} uniqueKey="id" />
          </div>
        </div>
      </FormComponent.Form>
    </UiComponent.Box>
  );
}

export default Filter;
